<template>
	<div class="flex wrap xs-12 b1 bc7 p2">
		<!-- mjml -->
		<p class="fs4 fw7 c6">{{ $t("mjml") }}</p>

		<core-monaco-editor language="html" v-model="computedMjml" />

		<!-- GraphQL Query -->
		<p class="fs4 fw7 c6">{{ $t("graphql_query") }}</p>
		<core-monaco-editor language="graphql" v-model="computedGraphQlQuery" />

		<!-- GraphQL Variables -->
		<p class="fs4 fw7 c6">{{ $t("graphql_variables") }}</p>
		<core-monaco-editor language="graphql" v-model="computedGraphQlVariables" />

		<!-- JSON Data we get from graphql query -->
		<!-- TODO: Hide for now -->
		<!-- <p class="fs4 fw7 c6">{{ $t("json_data") }}</p>-->
		<!-- <core-monaco-editor language="json" v-model="computedJsonData" /> -->
	</div>
</template>

<script>
import CoreMonacoEditor from "@/modules/core/components/CoreMonacoEditor"
import debounce from "lodash.debounce"

export default {
	components: {
		CoreMonacoEditor
	},

	props: {
		payload: {
			type: Object,
			default: () => ({
				mjml: "",
				graphQlQuery: "",
				graphQlVariables: "",
				jsonData: ""
			})
		}
	},

	data() {
		return {
			mjml: "",
			graphQlQuery: "",
			graphQlVariables: ""
		}
	},

	computed: {
		computedMjml: {
			get: function() {
				return this.payload.mjml
			},
			set: function(newValue) {
				this.mjml = newValue
				this.onMjmlChange()
			}
		},
		computedGraphQlQuery: {
			get: function() {
				return this.payload.graphQlQuery
			},
			set: function(newValue) {
				this.graphQlQuery = newValue
				this.onGraphQlQueryChange()
			}
		},
		computedGraphQlVariables: {
			get: function() {
				return this.payload.graphQlVariables
			},
			set: function(newValue) {
				this.graphQlVariables = newValue
				this.onGraphQlVariablesChange()
			}
		},
		computedJsonData() {
			return this.payload.jsonData
		}
	},

	methods: {
		onMjmlChange: debounce(function() {
			this.$emit("updated:mjml", this.mjml)
		}, 500),

		onGraphQlQueryChange: debounce(function() {
			this.$emit("updated:graphQlQuery", this.graphQlQuery)
		}, 500),

		onGraphQlVariablesChange: debounce(function() {
			this.$emit("updated:graphQlVariables", this.graphQlVariables)
		}, 500)
	}
}
</script>